import React, { useState } from "react";
import { server } from "../../../common";
import { useSelectAccess } from "../../../store/stateFunctions";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { AxiosError } from "axios";
import MurticarUserApplicationModal from "./MurticarUserApplicationModal";

const MurticarTotalApptions = ({ role }) => {
  const [data, setData] = useState([]);
  const user = useSelectAccess(role);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);

  const [contactNo, setContactNo] = useState("");
  const [applicantName, setApplicantName] = useState("");
  const [applicationNo, setApplicationNo] = useState("");
  const [status, setStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");


  const handleShow = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getData(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Get
  const getData = (page) => {
    server
      .get(`/murticar/getallappl?page=${page}&limit=10`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data.results); // Set the data array correctly
          setTotalPages(response.data.totalPages);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else {
          toast.error(error.response.data.error);
        }
      });
  };

  // search
  const SearchData = (searchValue) => {
    server
      .get(`/murticar/searchmurtikarbyid?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };


  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return "N/A";
    try {
      const date = new Date(dateTimeString);
      const formattedDate = date.toLocaleDateString("en-IN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      const formattedTime = date.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      return `${formattedDate}     ,  ${formattedTime}`;
    } catch {
      return dateTimeString;
    }
  };


  const applyFilter = () => {
    server
      .put("/murticar/getallappl/filter", {
 mobile: contactNo,         
 applicantName,
        applicationNo,
              permission_status: status,      // ✅ backend expects "permission_status"
        fromDate,
        toDate,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
        params: {
          page: 1,
          limit: 20,
        },
      })
      .then((response) => {
        console.log("api filter response", response.data);

        setData(response.data.results);
        setTotalPages(response.data.totalPages);

        toast.success("Filter applied successfully!");
      })
      .catch(handleApiError);
  };

  const handleApiError = (error) => {
    console.error("API Error:", error);

    if (error instanceof AxiosError && error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error.response?.data?.error) {
      toast.error(error.response.data.error);
    } else if (error.response?.status === 401) {
      toast.error("Authentication failed. Please login again.");
    } else if (error.response?.status === 403) {
      toast.error("Access denied. Insufficient permissions.");
    } else if (error.response?.status === 404) {
      toast.error("Endpoint not found. Please contact support.");
    } else if (error.response?.status >= 500) {
      toast.error("Server error. Please try again later.");
    } else {
      toast.error("Failed to connect to server");
    }
  };

  return (
    <>
      <div className="container mt-4">
        <div className="card mb-3">
          <div className="card-header">Search Application</div>
          <div className="card-body row">
            <div className="form-group col-md-5">
              <label>अँप्लिकेशन नंबर/नाव/उत्सव :</label>
              <input
                type="search"
                className="form-control"
                placeholder="Search "
                onChange={(e) => SearchData(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="row g-3 align-items-end">


          <div className="col-lg-2 col-md-3">
            <label className="form-label">From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="col-lg-2 col-md-3">
            <label className="form-label">To Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="col-lg-2 col-md-3">
            <label className="form-label">Contact No</label>
            <input
              type="text"
              className="form-control"
              value={contactNo}
              onChange={(e) => setContactNo(e.target.value)}
            />
          </div>

          {/* <div className="col-lg-2 col-md-3">
    <label className="form-label">Applicant Name</label>
    <input
      type="text"
      className="form-control"
      value={applicantName}
      onChange={(e) => setApplicantName(e.target.value)}
    />
  </div> */}

          <div className="col-lg-2 col-md-3">
            <label className="form-label">Application No</label>
            <input
              type="text"
              className="form-control"
              value={applicationNo}
              onChange={(e) => setApplicationNo(e.target.value)}
            />
          </div>

          <div className="col-lg-2 col-md-3">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">All</option>
              <option value="PENDING">Pending</option>
              <option value="APPROVED">Approved</option>
              <option value="REVIEWED">Rejected</option>
            </select>
          </div>



          <div className="col-lg-2 col-md-3">
            <button
              className="btn btn-primary w-100"
              onClick={applyFilter}
            >
              Apply Filter
            </button>
          </div>
        </div>

        <div className=" mt-4">
          <div className="card mb-3">
            <div className="card-header">Total Application</div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead className="thead-dark">
                    <tr>
                      <th>Sr.No.</th>
                      <th>Application No.</th>
                      <th>Application Date/Time</th>
                      <th>Applicant</th>
                      <th>Applicant Name</th>
                      <th>Address</th>
                      <th>Contact No.</th>
                      <th>Status</th>



                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => {
                      return (
                        <>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{item.id}</td>
                            <td>{formatDateTime(item.created_at)}</td>
                            <td>{item.applicant}</td>
                            <td>{item.name}</td>
                            <td>{item.address}</td>
                            <td>{item.mobile}</td>
                            <td>{item.permission_status}</td>

                            <td>
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={() => handleShow(item.id)}
                              >
                                View
                              </button>
                              {/* <button className="btn btn-info btn-sm my-2">
                          Approve
                        </button>
                        <button className="btn btn-danger btn-sm my-2">
                          Reject
                        </button> */}
                            </td>
                          </tr>
                          {/* Add more rows here */}
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-center">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </button>
              </li>

              {Array.from(
                { length: Math.min(10, totalPages) }, // Show up to 10 pages at a time
                (_, index) => {
                  const startPage = Math.max(1, currentPage - 5); // Dynamically calculate start page
                  const page = startPage + index;

                  if (page <= totalPages) {
                    return (
                      <li
                        key={page}
                        className={`page-item ${currentPage === page ? "active" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(page)}
                        >
                          {page}
                        </button>
                      </li>
                    );
                  } else {
                    return null;
                  }
                }
              )}

              <li
                className={`page-item ${currentPage === totalPages ? "disabled" : ""
                  }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <MurticarUserApplicationModal
        show={showModal}
        handleClose={handleClose}
        id={selectedId}
        role={role}
      />
    </>
  );
};

export default MurticarTotalApptions;
